import { useTranslation } from "react-i18next";
import AddressForm from "./form";
import { Drawer } from "antd";

const AddressModal = ({
  cities,
  formRef,
  getCities,
  handleDrawer,
  loading,
  open,
  provinces,
  onFinishAddAddress,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      destroyOnClose={true}
      key="bottom"
      open={open}
      placement={window.innerWidth < 768 ? "bottom" : "left"}
      title={t("card-page.add-address")}
      onClose={() => handleDrawer(false)}
    >
      <AddressForm
        cities={cities}
        formRef={formRef}
        getCities={getCities}
        loading={loading}
        provinces={provinces}
        onFinishAddAddress={onFinishAddAddress}
      />
    </Drawer>
  );
};
export default AddressModal;
